import React from 'react';
import LoadingSpinner from '../LoadingSpinner/loadingSpinner.js';

/**
 * Toggle component for boolean inputs
 * @param {Object} props - Component props
 * @returns {JSX.Element} Toggle component
 */
const Toggle = ({
  id,
  checked,
  onChange,
  label,
  disabled = false,
  className = '',
  labelClassName = '',
  toggleClassName = '',
  renderLabel = null
}) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className={`flex items-center ${className}`}>
      {renderLabel ? (
        renderLabel(toggleId)
      ) : label && (
        <label 
          htmlFor={toggleId} 
          className={`mr-2 text-sm font-medium ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type="checkbox"
          name={toggleId}
          id={toggleId}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={`toggle-checkbox`}
        />
        <label
          htmlFor={toggleId}
          className={`toggle-label ${toggleClassName} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        ></label>
        {disabled && (
          <div className="absolute inset-0 flex items-center justify-center">
            <LoadingSpinner size="small" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Toggle;
